import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import { useAuthStore, type TenantSummary, type User } from '@store/authStore';

interface CurrentUserResponse extends User {}

export const useMyTenants = () => {
  return useQuery({
    queryKey: ['auth', 'tenants'],
    queryFn: async () => {
      const { data } = await apiClient.get<TenantSummary[]>('/auth/tenants');
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useSwitchActiveTenant = () => {
  const queryClient = useQueryClient();
  const { setCurrentUser, setActiveTenantId } = useAuthStore();

  return useMutation({
    mutationFn: async (tenantId: string) => {
      const tenantHeader = { 'X-Active-Tenant-ID': tenantId };
      setActiveTenantId(tenantId);
      await apiClient.post('/auth/active-tenant', { tenant_id: tenantId }, {
        headers: tenantHeader,
      });
      const { data } = await apiClient.get<CurrentUserResponse>('/auth/me', {
        headers: tenantHeader,
      });
      return data;
    },
    onSuccess: (data) => {
      setCurrentUser(data);
      queryClient.clear();
    },
    onError: () => {
      setActiveTenantId(useAuthStore.getState().currentUser?.active_tenant_id ?? null);
    },
  });
};
